import { Outlet } from 'react-router-dom';

const MinimalLayout = () => {
    return (
        <>
            <Outlet />
        </>
    );
};

export default MinimalLayout;
